import React, { Component } from "react";
import { Card, CardBody, Form, FormGroup, Input, Label } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import Select from "react-select";
import Creatable from "../../components/common/CreatableSelect";
import { Wizard, Steps, Step } from "react-albus";
import { injectIntl } from "react-intl";
import { BottomNavigation } from "../../components/wizard/BottomNavigation";
import { TopNavigation } from "../../components/wizard/TopNavigation";
import { GetBank, SetBank } from "../../helpers/ListBank";
import CustomSelectInput from "../../components/common/CustomSelectInput";
import Axios from "axios";
import { END_POINT } from "../../constants/defaultValues";
import {
  NotificatioErrController,
  NotificatioSucController,
} from "../../helpers/Utils";
import LogsHelper from "../../helpers/Logs";
import { Colxx } from "../../components/common/CustomBootstrap";

class Basic extends Component {
  constructor(props) {
    super(props);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrev = this.onClickPrev.bind(this);
    this.topNavClick = this.topNavClick.bind(this);
    this.state = {
      isLoading: false,
      initialFormData: null,
      categories: [],
      products: [],
      visibleSteps: {
        step1: true,
        step2: true,
        step3: true,
      },
      formData: {
        domain: "",
        companyName: "",
        phone: "",
        email: "",
        address: "",
        products: [
          { id: 1, nameProduct: "", category: "", price: "" },
          { id: 2, nameProduct: "", category: "", price: "" },
          { id: 3, nameProduct: "", category: "", price: "" },
        ],
        bankPay: "",
        namePay: "",
        numberPay: "",
      },
    };
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    try {
      const [savedData] = await Promise.all([
        this.dataRenderUser(),
        this.dataRenderProducts(),
        this.dataRenderCategories(),
      ]);

      // Set formData first so validation checks inside isStepXComplete run on the loaded data
      this.setState({
        formData: savedData,
      }, () => {
        const showStep1 = !this.isStep1Complete();
        const showStep2 = !this.isStep2Complete();
        const showStep3 = !this.isStep3Complete();

        const allComplete = !showStep1 && !showStep2 && !showStep3;

        this.setState({
          visibleSteps: {
            step1: allComplete ? true : showStep1,
            step2: allComplete ? true : showStep2,
            step3: allComplete ? true : showStep3,
          },
          initialFormData: savedData, // Trigger the wizard rendering only after steps have been calculated
        });
      });
    } catch (err) {
      console.error("Error loading wizard steps:", err);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  dataRenderUser = () => {
    let tokenStr = localStorage.getItem("access_token");
    return Axios.get(`${END_POINT + "/user"}`, {
      headers: {
        Authorization: `Bearer ${tokenStr}`,
      },
    })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        console.log("data: ", data.data);
        const savedData = {
          companyName: data.data.companyName || "",
          domain: data.data.domain || "",
          phone: data.data.phoneNumber || data.data.hotline || "", // Ưu tiên số đăng ký, fallback hotline
          email: data.data.email || "",
          address: data.data.companyAddress || data.data.address || "",
          namePay: data.data.namePay || "",
          numberPay: data.data.numberPay || "",
          bankPay: data.data.bankPay || "",
          login_status: data.data.login_status || "",
          products: [
            { id: 1, nameProduct: "", category: "", price: "" },
            { id: 2, nameProduct: "", category: "", price: "" },
            { id: 3, nameProduct: "", category: "", price: "" },
          ],
        };

        this.props.handleLoginStatus(data.data.login_status);
        return savedData;
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText);
        throw err;
      });
  };

  dataRenderProducts = () => {
    let tokenStr = localStorage.getItem("access_token");
    return Axios.get(`${END_POINT + "/product/all"}`, {
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((res) => {
        this.setState({
          products: res.data.data,
        });
      })
      .catch((err) => []);
  };

  dataRenderCategories = () => {
    let tokenStr = localStorage.getItem("access_token");
    return Axios.get(`${END_POINT + "/category"}`, {
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((res) => {
        this.setState({
          categories: res.data.data,
        });
      })
      .catch((err) => []);
  };

  topNavClick(stepItem, push) {
    push(stepItem.id);
  }

  onClickNext(goToNext, steps, step) {
    step.isDone = true;
    if (steps.length - 1 <= steps.indexOf(step)) {
      return;
    }
    goToNext();
  }

  onClickPrev(goToPrev, steps, step) {
    if (steps.indexOf(step) <= 0) {
      return;
    }
    goToPrev();
  }

  // Hàm xử lý khi input thay đổi
  handleInputChange = (e, _name) => {
    if (!e) return false;
    if (e.target) {
      const { name, value } = e.target;
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          [name]: value,
        },
      }));
    } else {
      let value = e;
      if (_name === "bankPay") {
        value = e.value;
        // console.log('value: ', value);
      }
      this.setState((prev) => ({
        ...prev,
        formData: {
          ...prev.formData,
          [_name]: value,
        },
      }));
    }
  };

  handleProductChange = (event, index, _name) => {
    if (event && event.target) {
      // 1. Lấy ra name và value từ input
      const { name, value } = event.target;

      // 2. Tạo một bản sao của mảng products để không thay đổi state trực tiếp (nguyên tắc bất biến)
      const updatedProducts = [...this.state.formData.products];

      // 3. Cập nhật đúng trường (`name`) của đúng sản phẩm (`index`)
      updatedProducts[index] = {
        ...updatedProducts[index],
        [name]: value,
      };

      // 4. Cập nhật lại state với mảng products đã được thay đổi
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          products: updatedProducts,
        },
      }));
    } else {
      const updatedProducts = [...this.state.formData.products];

      // 3. Cập nhật đúng trường (`name`) của đúng sản phẩm (`index`)
      updatedProducts[index] = {
        ...updatedProducts[index],
        [_name]: event,
      };

      // 4. Cập nhật lại state với mảng products đã được thay đổi
      this.setState((prevState) => {
        let newState = {
          formData: {
            ...prevState.formData,
            products: updatedProducts,
          },
        };

        // 5. Nếu đang tạo category mới, thêm vào danh sách categories để có thể chọn lại
        if (_name === "category" && event && event.__isNew__) {
          const newCategory = {
            id: event.value, // Creatable thường dùng value làm id
            label: event.label,
            value: event.value,
          };
          // Kiểm tra xem category đã tồn tại chưa
          const exists = prevState.categories.some(
            (cat) =>
              cat.label === newCategory.label ||
              cat.value === newCategory.value,
          );
          if (!exists) {
            newState.categories = [...prevState.categories, newCategory];
          }
        }

        return newState;
      });
    }
  };

  // Hàm kiểm tra sự thay đổi của Step 1
  hasStep1DataChanged = () => {
    const { formData, initialFormData } = this.state;
    // Nếu chưa có dữ liệu gốc, coi như có thay đổi
    if (!initialFormData) return true;

    // Chỉ lấy các trường liên quan đến Step 1
    const currentStep1Data = {
      companyName: formData.companyName,
      phone: formData.phone,
      email: formData.email,
      address: formData.address,
    };
    const initialStep1Data = {
      companyName: initialFormData.companyName,
      phone: initialFormData.phone,
      email: initialFormData.email,
      address: initialFormData.address,
    };

    // So sánh chuỗi JSON của hai object
    return (
      JSON.stringify(currentStep1Data) !== JSON.stringify(initialStep1Data)
    );
  };

  // Hàm kiểm tra sự thay đổi của Step 2 (products)
  hasStep2DataChanged = () => {
    const { formData, initialFormData } = this.state;
    if (!initialFormData) return true;

    // So sánh trực tiếp mảng products
    return (
      JSON.stringify(formData.products) !==
      JSON.stringify(initialFormData.products)
    );
  };

  hasStep3DataChanged = () => {
    const { formData, initialFormData } = this.state;
    // Nếu chưa có dữ liệu gốc, coi như có thay đổi
    if (!initialFormData) return true;

    // Chỉ lấy các trường liên quan đến Step 1
    const currentStep1Data = {
      namePay: formData.namePay,
      numberPay: formData.numberPay,
      bankPay: formData.bankPay,
    };
    const initialStep1Data = {
      namePay: initialFormData.namePay,
      numberPay: initialFormData.numberPay,
      bankPay: initialFormData.bankPay,
    };

    // So sánh chuỗi JSON của hai object
    return (
      JSON.stringify(currentStep1Data) !== JSON.stringify(initialStep1Data)
    );
  };

  isStep1Complete = () => {
    const { companyName, phone, email, address } = this.state.formData || {};
    return Boolean(
      companyName &&
      companyName.trim().length > 4 &&
      phone &&
      phone.trim().length >= 10 &&
      email &&
      email.includes("@") &&
      email.trim().length > 5 &&
      address &&
      address.trim().length > 4
    );
  };

  isStep2Complete = () => {
    if (this.state.products && this.state.products.length > 0) {
      return true;
    }
    const { products } = this.state.formData || {};

    // Tìm xem có sản phẩm nào đã được điền thông tin hay chưa
    const filledProducts = products?.filter(
      (p) =>
        p.nameProduct && p.nameProduct.trim() !== "" &&
        p.category && p.category !== "" &&
        p.price && String(p.price).trim() !== "",
    );

    // Nếu có ít nhất 1 sản phẩm được điền thì coi như bước này "hoàn thành"
    return filledProducts?.length > 0;
  };

  isStep3Complete = () => {
    const { bankPay, namePay, numberPay } = this.state.formData || {};
    return Boolean(
      numberPay && String(numberPay).trim() !== "" &&
      namePay && String(namePay).trim() !== "" &&
      bankPay && String(bankPay).trim() !== ""
    );
  };

  validationStatus = () => ({
    step1: this.isStep1Complete(),
    step2: this.isStep2Complete(), // Giả sử bạn có hàm này
    step3: this.isStep3Complete(), // Giả sử bạn có hàm này
  });

  handleWizardFinish = async () => {
    // Submit step 3 data if it changed and is complete
    if (this.hasStep3DataChanged() && this.isStep3Complete()) {
      this.setState({ isLoading: true });
      try {
        await this.submitStep3Data();
      } catch (error) {
        console.error("Error submitting step 3 data on finish:", error);
      } finally {
        this.setState({ isLoading: false });
      }
    }

    // 1. Wait for the status update to complete on the server
    await this.handleUpdateLoginStatus();

    // 2. Notify parent component to refresh data (realtime update)
    if (this.props.onWizardComplete) {
      this.props.onWizardComplete();
    }

    // 3. Close modal AND tell parent to SKIP its own update (pass true)
    this.props.onToggle(true);
  };

  handleUpdateLoginStatus = () => {
    const { companyName, phone, email, address, namePay, bankPay, numberPay } =
      this.state.formData;

    let wizard_status;
    if (
      companyName === "" ||
      phone === "" ||
      email === "" ||
      address === "" ||
      namePay === "" ||
      bankPay === "" ||
      numberPay === "" ||
      this.state.products.length < 1
    ) {
      wizard_status = "wizard_pending";
    } else {
      wizard_status = "wizard_complete";
    }

    let formData = new FormData();

    formData.append("login_status", wizard_status);

    // axios submit
    let tokenStr = localStorage.getItem("access_token");
    // Return the promise so handleWizardFinish can await it
    return Axios.put(`${END_POINT + "/user"}`, formData, {
      headers: {
        Authorization: `Bearer ${tokenStr}`,
        "content-type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        // NotificatioSucController(data.responseText);
      })
      .catch((err) => {
        // NotificatioErrController(err.response.data.responseText);
      });
  };

  // Hàm gửi dữ liệu của Step 1
  submitStep1Data = () => {
    const { companyName, phone, email, address } = this.state.formData;
    // const payload = { companyName, phone, email, address };

    let formData = new FormData();

    formData.append("phoneNumber", phone);
    formData.append("email", email);
    formData.append("address", address);
    formData.append("companyName", companyName);
    formData.append("companyAddress", address);
    formData.append("hotline", phone);

    // axios submit
    let tokenStr = localStorage.getItem("access_token");
    Axios.put(`${END_POINT + "/user"}`, formData, {
      headers: {
        Authorization: `Bearer ${tokenStr}`,
        "content-type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificatioSucController(data.responseText);
      })
      .catch((err) => {
        // NotificatioErrController(err.response.data.responseText);
      });

    // return new Promise(resolve => setTimeout(resolve, 500));
  };

  // Hàm gửi dữ liệu của Step 2 (sản phẩm)
  submitStep2Data = () => {
    const { products } = this.state.formData;
    const productNotEmpty = products.filter(
      (p) => p.nameProduct !== "" && p.category && p.price !== "",
    );
    // Loại bỏ dấu chấm phân cách hàng nghìn (format VN: 250.000 -> 250000)
    const productValid = productNotEmpty.map((p) => {
      // Kiểm tra xem category_id có phải là số nguyên hợp lệ không
      // Nếu category được tạo mới từ Creatable, p.category.id sẽ là text (tên category)
      const categoryId = p.category.id;
      const isValidCategoryId =
        categoryId &&
        Number.isInteger(Number(categoryId)) &&
        !p.category.__isNew__;

      return {
        name: p.nameProduct,
        price: String(p.price).replace(/\./g, "").replace(/,/g, ""), // Xóa dấu . và , để có số thuần
        category_id: isValidCategoryId ? categoryId : null, // Chỉ gửi ID nếu là số nguyên hợp lệ
        category_name: p.category.label, // Luôn gửi tên để server có thể tạo mới nếu cần
      };
    });

    let tokenStr = localStorage.getItem("access_token");

    // Kiểm tra xem token có tồn tại không
    if (!tokenStr) {
      NotificatioErrController(
        "Lỗi: Chưa đăng nhập hoặc không tìm thấy token.",
      );
      return; // Dừng thực thi nếu không có token
    }

    // Kiểm tra xem END_POINT có được định nghĩa không
    if (!END_POINT) {
      NotificatioErrController("Lỗi: Cấu hình END_POINT bị thiếu.");
      return;
    }

    Axios.post(
      `${END_POINT + "/product/import-product"}`,
      { data: productValid },
      {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      },
    )
      .then((res) => res.data)
      .then((responseData) => {
        console.log("Server Response:", responseData); // Log phản hồi từ server
        NotificatioSucController(responseData.message || "Import thành công!"); // Hiển thị thông báo từ server

        // Nếu có sản phẩm import thành công
        const successful = responseData.data?.successful;
        if (successful && successful.length > 0) {
          console.log("Import thành công:", successful.length, "sản phẩm");
        }
      })
      .catch((err) => {
        console.error("Lỗi khi import product:", err);
        const errorMsg =
          err.response?.data?.message ||
          "Có lỗi xảy ra, không thể gửi yêu cầu đến server.";
        NotificatioErrController(errorMsg);
      });

    return new Promise((resolve) => setTimeout(resolve, 500));
  };

  // Tương tự cho Step 3 nếu có
  submitStep3Data = () => {
    const { namePay, numberPay, bankPay } = this.state.formData;

    let formData = new FormData();

    formData.append("namePay", namePay);
    formData.append("numberPay", numberPay);
    formData.append("bankPay", bankPay);

    // axios submit
    let tokenStr = localStorage.getItem("access_token");
    Axios.put(`${END_POINT + "/user"}`, formData, {
      headers: {
        Authorization: `Bearer ${tokenStr}`,
        "content-type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificatioSucController(data.responseText);
      })
      .catch((err) => {
        // NotificatioErrController(err.response.data.responseText);
      });

    return new Promise((resolve) => setTimeout(resolve, 500));
  };

  // Hàm này được gọi khi người dùng bấm nút "Tiếp theo"
  onClickNext = (next, steps, step) => {
    // Dùng switch-case dựa trên ID của step hiện tại
    switch (step.id) {
      case "step1": {
        // 1. Kiểm tra validation của step 1
        if (!this.isStep1Complete()) {
          // Nếu không hợp lệ, hiển thị thông báo và dừng lại
          // alert("Vui lòng nhập đầy đủ thông tin cửa hàng!"); // Thay bằng Toast cho đẹp hơn
          next();
        }

        // 2. KIỂM TRA XEM DỮ LIỆU CÓ THAY ĐỔI KHÔNG
        if (this.hasStep1DataChanged()) {
          // Nếu có thay đổi, thì mới thực hiện push data
          console.log("Dữ liệu Step 1 đã thay đổi, đang push lên DB...");
          this.setState({ isLoading: true });
          try {
            if (this.isStep1Complete()) {
              this.submitStep1Data();
            }
            // Sau khi push thành công, cập nhật lại initialFormData để nó trở thành "bản gốc" mới
            this.setState((prevState) => ({
              initialFormData: {
                ...prevState.initialFormData,
                companyName: prevState.formData.companyName,
                phone: prevState.formData.phone,
                email: prevState.formData.email,
                address: prevState.formData.address,
              },
            }));
          } catch (error) {
            // ... xử lý lỗi
            this.setState({ isLoading: false });
            return; // Dừng lại nếu API lỗi
          } finally {
            this.setState({ isLoading: false });
          }
        } else {
          // Nếu không có thay đổi, chỉ log ra và bỏ qua bước submit
          console.log("Dữ liệu Step 1 không thay đổi, bỏ qua push.");
        }

        break;
      }

      case "step2": {
        // Logic tương tự cho Step 2
        if (!this.isStep2Complete()) {
          // alert("Vui lòng nhập ít nhất một sản phẩm!");
          next();
        }

        if (this.hasStep2DataChanged()) {
          console.log("Dữ liệu Step 2 đã thay đổi, đang push lên DB...");
          this.setState({ isLoading: true });
          try {
            if (this.isStep2Complete()) {
              this.submitStep2Data();
            }
            // Cập nhật lại bản gốc cho products
            this.setState((prevState) => ({
              initialFormData: {
                ...prevState.initialFormData,
                products: prevState.formData.products,
              },
            }));
          } catch (error) {
            console.error("Lỗi khi submit Step 2:", error);
            alert("Đã có lỗi xảy ra.");
            this.setState({ isLoading: false });
            return;
          } finally {
            this.setState({ isLoading: false });
          }
        } else {
          console.log("Dữ liệu Step 2 không thay đổi, bỏ qua push.");
        }

        break;
      }

      case "step3": {
        if (!this.isStep3Complete()) {
          // alert("Vui lòng hoàn thiện thông tin thanh toán");
          next();
        }

        // 2. KIỂM TRA XEM DỮ LIỆU CÓ THAY ĐỔI KHÔNG
        if (this.hasStep3DataChanged()) {
          // Nếu có thay đổi, thì mới thực hiện push data
          console.log("Dữ liệu Step 3 đã thay đổi, đang push lên DB...");
          this.setState({ isLoading: true });
          try {
            if (this.isStep3Complete()) {
              this.submitStep3Data();
            }
            // Sau khi push thành công, cập nhật lại initialFormData để nó trở thành "bản gốc" mới
            this.setState((prevState) => ({
              initialFormData: {
                ...prevState.initialFormData,
                namePay: prevState.formData.namePay,
                numberPay: prevState.formData.numberPay,
                bankPay: prevState.formData.bankPay,
              },
            }));
          } catch (error) {
            // ... xử lý lỗi
            this.setState({ isLoading: false });
            return; // Dừng lại nếu API lỗi
          } finally {
            this.setState({ isLoading: false });
          }
        } else {
          // Nếu không có thay đổi, chỉ log ra và bỏ qua bước submit
          console.log("Dữ liệu Step 3 không thay đổi, bỏ qua push.");
        }

        break;
      }

      default:
        next();
      // Mặc định, nếu không có logic đặc biệt thì chỉ cần chuyển bước
    }
    next();
  };

  renderSteps = (messages, companyName, phone, email, address, products, bankPay, namePay, numberPay) => {
    const steps = [];
    
    if (this.state.visibleSteps.step1) {
      steps.push(
        <Step
          key="step1"
          id="step1"
          name={messages["wizard.step-name-1"]}
          desc={messages["wizard.step-desc-1"]}
          isComplete={this.isStep1Complete()}
        >
          <div className="wizard-basic-step text-center">
            <p>
              Thông tin cơ bản này sẽ hiển thị khi in hóa đơn. Hãy điền
              đầy đủ nhé!
            </p>
            <Form className="w-40 w-xs-100 mx-auto">
              <FormGroup className="has-float-label">
                <Label>
                  <IntlMessages id="profile.companyName" />
                </Label>
                <Input
                  type="text"
                  name="companyName"
                  placeholder={messages["profile.companyName"]}
                  value={companyName}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label>
                  <IntlMessages id="profile.phone" />
                </Label>
                <Input
                  type="phone"
                  name="phone"
                  placeholder={messages["profile.phone"]}
                  value={phone}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label>
                  <IntlMessages id="profile.email" />
                </Label>
                <Input
                  type="email"
                  name="email"
                  placeholder={messages["profile.email"]}
                  value={email}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label>
                  <IntlMessages id="profile.address" />
                </Label>
                <Input
                  type="text"
                  name="address"
                  placeholder={messages["profile.address"]}
                  value={address}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
            </Form>
          </div>
        </Step>
      );
    }

    if (this.state.visibleSteps.step2) {
      steps.push(
        <Step
          key="step2"
          id="step2"
          name={messages["wizard.step-name-2"]}
          desc={messages["wizard.step-desc-2"]}
          isComplete={this.isStep2Complete()}
        >
          <div className="wizard-basic-step text-center">
            <p>
              Sản phẩm là cốt lõi của cửa hàng, hãy thêm vài sản phẩm đầu
              tiên và trải nghiệm phần mềm!
            </p>
            <div style={{ overflowX: "auto", width: "100%" }}>
              <div style={{ minWidth: "550px" }}>
                {products?.map((product, index) => (
                  <Form
                    key={product.id}
                    className="d-flex align-items-center mx-auto mb-3 product-entry-row"
                    style={{ minWidth: "530px" }}
                  >
                    <div className="mr-3" style={{ minWidth: "20px" }}>
                      {index + 1}
                    </div>

                    <div
                      style={{
                        minWidth: "150px",
                        flex: 1,
                        paddingRight: "8px",
                      }}
                    >
                      <FormGroup className="has-float-label mb-0">
                        <Label>
                          <IntlMessages id="pages.product-name" />
                        </Label>
                        <Input
                          type="text"
                          name="nameProduct"
                          placeholder={messages["pages.product-name"]}
                          value={product.nameProduct}
                          onChange={(e) =>
                            this.handleProductChange(e, index)
                          }
                        />
                      </FormGroup>
                    </div>
                    <div
                      style={{
                        minWidth: "200px",
                        flex: 1,
                        paddingRight: "8px",
                      }}
                    >
                      <FormGroup className="has-float-label mb-0">
                        <Label>
                          <IntlMessages id="pages.category" />
                        </Label>
                        <Creatable
                          placeholder="Chọn hoặc tạo mới"
                          isClearable
                          className={"react-select-creatable"}
                          onChange={(e) =>
                            this.handleProductChange(e, index, "category")
                          }
                          options={this.state.categories}
                          name="category"
                          id="category"
                          value={product?.category}
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </FormGroup>
                    </div>
                    <div style={{ minWidth: "120px", flex: 1 }}>
                      <FormGroup className="has-float-label mb-0">
                        <Label>
                          <IntlMessages id="product.price.original" />
                        </Label>
                        <Input
                          type="number"
                          name="price"
                          placeholder={messages["product.price.original"]}
                          value={product.price}
                          onChange={(e) =>
                            this.handleProductChange(e, index)
                          }
                        />
                      </FormGroup>
                    </div>
                  </Form>
                ))}
              </div>
            </div>
          </div>
        </Step>
      );
    }

    if (this.state.visibleSteps.step3) {
      steps.push(
        <Step
          key="step3"
          id="step3"
          name={messages["wizard.step-name-3"]}
          desc={messages["wizard.step-desc-3"]}
          isComplete={this.isStep3Complete()}
        >
          <div className="wizard-basic-step d-flex flex-column align-items-center">
            <p className="w-30 w-xs-100 text-center">
              Thông tin thanh toán để hiển thị lên hóa đơn, khách hàng có
              thể nhìn thấy và chuyển khoản cho bạn thông qua mã Qr được
              tạo tự động!
            </p>
            <Form className="w-40 w-xs-100 mx-auto">
              <FormGroup className="has-float-label">
                <Select
                  defaultValue={GetBank(bankPay)}
                  components={{ Input: CustomSelectInput }}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="bankPay"
                  placeholder={"Chọn ngân hàng"}
                  options={SetBank}
                  onChange={(e) => this.handleInputChange(e, "bankPay")}
                  menuPlacement="bottom"
                />
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label>
                  <IntlMessages id="profile.namePay" />
                </Label>
                <Input
                  type="text"
                  name="namePay"
                  placeholder={messages["profile.namePay"]}
                  value={namePay}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label>
                  <IntlMessages id="profile.numberPay" />
                </Label>
                <Input
                  type="text"
                  name="numberPay"
                  placeholder={messages["profile.numberPay"]}
                  value={numberPay}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
            </Form>
          </div>
        </Step>
      );
    }

    return steps;
  };

  render() {
    if (!this.state.initialFormData) {
      return (
        <div className="loading" />
      );
    }
    const { messages } = this.props.intl;
    const {
      domain,
      companyName,
      phone,
      address,
      email,
      products,
      bankPay,
      namePay,
      numberPay,
    } = this.state.formData;
    return (
      <Card>
        <CardBody className="wizard wizard-default">
          <p className="mt-4 w-50 w-xs-100 text-center ml-auto mr-auto">
            Chào mừng <strong>{companyName ? companyName : domain}</strong>. Hãy
            cùng thiết lập vài bước đầu tiên để cửa hàng có thể hoạt động nhé!
          </p>
          <Wizard>
            <TopNavigation
              className="justify-content-center"
              disableNav={false}
              topNavClick={this.topNavClick}
              isComplete={this.isStep1Complete()}
              validationStatus={this.validationStatus()}
            />
            <Steps>
              {this.renderSteps(messages, companyName, phone, email, address, products, bankPay, namePay, numberPay)}
            </Steps>
            <BottomNavigation
              onClickNext={this.onClickNext}
              onClickPrev={this.onClickPrev}
              className="justify-content-center"
              prevLabel={messages["wizard.prev"]}
              nextLabel={messages["wizard.next"]}
              onFinish={this.handleWizardFinish}
              finishLabel="Xong"
              isLoading={this.state.isLoading}
            />
          </Wizard>
        </CardBody>
      </Card>
    );
  }
}
export default injectIntl(Basic);
